var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0C262F5-2C49-4F24-B495-A24EE0ED729C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rebates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lincolnrebates_redeemrebates_vinpopuptip_v2_Desktop",
    transform: "translate(-943.000000, -1721.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components/Overlays/ToolTip/PopUp",
    transform: "translate(678.000000, 1710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close",
    transform: "translate(265.956971, 11.050132)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Close",
    points: "14.0240964 1.2983905 12.6116695 0 7.01204819 5.14751979 1.41242685 0 0 1.2983905 5.59962134 6.44591029 0 11.5934301 1.41242685 12.8918206 7.01204819 7.74430079 12.6116695 12.8918206 14.0240964 11.5934301 8.42447504 6.44591029"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.576d4dbe1b4a5b3126ccf3144d3a51f8.svg";
export { ForwardRef as ReactComponent };